export const API_EXTERNAL_ENDPOINT = 'contacts/new'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/contacts/new'
